/* eslint-disable react/no-unescaped-entities */
import React from 'react';
// import { LazyLoadImage } from 'react-lazy-load-image-component';
// import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
// import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';

const mock = [
  
  {
    
    description:
      'Show and Tell',
    href : '/literary-club-2023'
 
  },
  {
    
    description:
      'English CCA',
    href : '/english-cca-2023'
 
  },
  {
    
    description:
      'Literacy Day',
    href : '/literacy-day-2023'
 
  },
  {
    
    description:
      'English  CCA - Class 1 & 2',
    href : '/english-cca-class1to2-2023'
 
  },
  {
    
    description:
      'Interview of Famous Personalities',
    href : '/interview-of-famous-personalities'
 
  },
  {
    
    description:
      'Literary Association Finals',
    href : '/association-finals-2023'
 
  },
  {
    
    description:
      'Kannada CCA - Class 3 to 5',
    href : '/kannada-cca-class3to5-2023'
 
  },
  {
    
    description:
      'Story Telling ',
    href : '/story-telling-2023'
 
  },
  {
    
    description:
      'Hindi CCA - Class 3 to 5',
    href : '/hindi-cca-2023'
 
  }

];

const Sidebar2023 = () => {
  
  return (
    <Box component={Card} variant={'outlined'} padding={2}>
      <Typography
        variant="h6"
        data-aos={'fade-up'}
        sx={{
          fontWeight: 700,
          marginBottom: 2,
        }}
      >
        Literary Club 2023-24
      </Typography>
      <Grid container spacing={2}>
        {mock.map((item, i) => (
          <Grid key={i} item xs={12}>
            <Box
              component={Card}
              width={1}
              height={1}
              boxShadow={0}
              borderRadius={0}
              display={'flex'}
              flexDirection={{ xs: 'column', md: 'row' }}
              sx={{ backgroundImage: 'none', bgcolor: 'transparent' }}
            >
              <Button href={item.href}>
                <Typography variant='h6'>
                  {item.description}
                  
                </Typography>
              </Button>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Sidebar2023;
